import { render, staticRenderFns } from "./PrevDetect.vue?vue&type=template&id=a45d41ce&scoped=true"
import script from "./PrevDetect.vue?vue&type=script&lang=js"
export * from "./PrevDetect.vue?vue&type=script&lang=js"
import style0 from "./PrevDetect.vue?vue&type=style&index=0&id=a45d41ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45d41ce",
  null
  
)

export default component.exports